/* eslint-disable no-console */
import { CheckboxStyle } from "@insite/mobius/Checkbox";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import getProp from "@insite/mobius/utilities/getProp";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

const _borderWidth = "2px";

export default {
    defaultProps: {
        color: "common.background",
        css: css`
            align-items: flex-start;

            span[role="checkbox"] {
                border-color: ${getColor("common.borderDark")};
                border-width: ${_borderWidth};
                cursor: pointer;
                margin-top: 0.1em;

                &[aria-checked="true"]:not([aria-disabled="true"]) {
                    border: 2px solid ${getColor("primary.dark")};
                    color: ${getColor("common.backgroundContrast")};
                    background-color: ${getColor("common.background")};

                    svg {
                        stroke: ${getColor("primary.dark")};
                    }
                }

                &[aria-disabled="true"] {
                    border: 2px solid ${getColor("common.disabled")};
                    color: ${getColor("common.disabled")};
                    background-color: ${getColor("common.background")};

                    &:hover {
                        border: 2px solid ${getColor("common.disabled")};
                        cursor: not-allowed;
                    }

                    svg {
                        stroke: ${getColor("common.disabled")};
                    }
                }

                &[aria-checked="false"] {
                    background-color: ${getColor("common.background")};
                    svg {
                        display: none;
                    }
                }

                &:focus {
                    box-shadow: none;
                    outline-color: ${getProp("theme.focus.color")};
                    outline-style: ${getProp("theme.focus.style")};
                    outline-width: ${_borderWidth};
                    outline-offset: -${_borderWidth};
                }

                + label {
                    margin: 0;
                    padding-left: 0.7em;
                    cursor: pointer;

                    &::before {
                        flex-shrink: 0;
                    }
                }
            }
        `,
    },
    groupDefaultProps: {
        labelProps: {
            size: TYPOGRAPHY.size.small,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            & > ${TypographyStyle}:first-child {
                margin-bottom: 5px;
            }
            
            ${CheckboxStyle} + ${CheckboxStyle} {
                margin-top: 0.5em;
            }
        `,
    },
};
